export const marketplaceMyListingsTour = {
  tourKey: 'marketplace_my_listings',
  conditions: {
    orgTypes: ['npo', 'business'],
    userTypes: ['admin', 'staff'],
    plans: null,
  },
  steps: [
    {
      // No target - centered welcome popover
      title: 'tours.marketplace-my-listings.welcome.title',
      content: 'tours.marketplace-my-listings.welcome.content',
      placement: 'center',
    },
    {
      target: '[data-tour="marketplace-create-listing"]',
      title: 'tours.marketplace-my-listings.create.title',
      content: 'tours.marketplace-my-listings.create.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="marketplace-status-tabs"]',
      title: 'tours.marketplace-my-listings.status-tabs.title',
      content: 'tours.marketplace-my-listings.status-tabs.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="marketplace-listings"]',
      title: 'tours.marketplace-my-listings.manage.title',
      content: 'tours.marketplace-my-listings.manage.content',
      placement: 'top',
    },
  ],
};
